<template>
  <ModalProvider
    id="modalDiscrepanciaUmbrales"
    size="lg"
  >
    <template #title>
      <i class="fas fa-exclamation-triangle"></i> Discrepancia de Totales en Factura.
    </template>

    <template #body>
      <div class="alert alert-warning border-0 shadow-sm">
        <i class="fas fa-info-circle"></i> La factura no puede cerrarse debido a una diferencia de Totales en Factura.
      </div>

      <!-- Serie -->
      <div
        v-if="discrepancia.serie"
        class="alert alert-success border-0 shadow-sm d-flex justify-content-between align-items-center"
      >
        <span><i class="fas fa-file-invoice"></i>&nbsp; <b>Serie:</b></span>
        <span>{{ discrepancia.serie }}</span>
      </div>

      <!-- Documento -->
      <div
        v-if="discrepancia.documento"
        class="alert alert-success border-0 shadow-sm d-flex justify-content-between align-items-center"
      >
        <span><i class="fas fa-file-invoice"></i>&nbsp; <b>Documento:</b></span>
        <span>{{ discrepancia.documento }}</span>
      </div>

      <!-- Tabla de diferencias -->
      <div class="row mt-2">
        <div class="col-12 mb-3">
          <div class="shadow-sm">
            <div class="bg-light py-2"><b>Resumen de Diferencia</b></div>
            <div class="p-0">
              <table class="table table-sm mb-0">
                <thead class="bg-light">
                  <tr>
                    <th class="pl-3">Concepto</th>
                    <th class="text-right">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="pl-3 py-2">Total Factura</td>
                    <td class="text-right py-2">Q {{ formatGBP(discrepancia.factura) }}</td>
                  </tr>
                  <tr>
                    <td class="pl-3 py-2">Total Conteo</td>
                    <td class="text-right py-2">Q {{ formatGBP(discrepancia.conteo) }}</td>
                  </tr>
                  <tr
                    class="font-weight-bold"
                    :class="discrepancia.tipo === 'Sobrante' ? 'text-danger' : 'text-warning'"
                  >
                    <td class="pl-3 py-2 border-top">Diferencia</td>
                    <td class="text-right py-2 border-top">Q {{ formatGBP(discrepancia.diferencia) }}</td>
                  </tr>
                  <tr class="table-danger">
                    <td class="pl-3 py-1"><i>Umbral Excedido Por</i></td>
                    <td class="text-right py-1 font-weight-bold">
                      {{
                        discrepancia.diferencia > 0
                          ? Math.max(0, (Math.abs(discrepancia.diferencia) / discrepancia.factura * 100) - (discrepancia.umbralSobrante * 100)).toFixed(4)
                          : Math.max(0, (Math.abs(discrepancia.diferencia) / discrepancia.factura * 100) - (Math.abs(discrepancia.umbralFaltante) * 100)).toFixed(4)
                      }}%
                    </td>
                  </tr>
                  <tr class="table-info">
                    <td class="pl-3 py-1"><i>Mínimo permitido</i></td>
                    <td class="text-right py-1">Q {{ formatGBP(discrepancia.minimo) }}</td>
                  </tr>
                  <tr class="table-info">
                    <td class="pl-3 py-1"><i>Máximo permitido</i></td>
                    <td class="text-right py-1">Q {{ formatGBP(discrepancia.maximo) }}</td>
                  </tr>
                  <tr class="table-info">
                    <td class="pl-3 py-1"><i>Umbral Aplicado</i></td>
                    <td class="text-right py-1">
                      {{ discrepancia.diferencia > 0 ? (discrepancia.umbralSobrante * 100).toFixed(4) : (Math.abs(discrepancia.umbralFaltante) * 100).toFixed(4) }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12 mb-3">
          <div class="bg-light py-2"><b>Posibles Causas</b></div>
        </div>
      </div>

      <!-- Carousel de posibles causas -->
      <div
        id="carouselPosiblesCausas"
        class="carousel slide bg-light rounded shadow-sm py-3"
        data-ride="carousel"
        data-interval="5000"
      >
        <div class="carousel-inner px-4">
          <div class="carousel-item active">
            <div class="alert alert-info border-0 m-0 text-center">
              <i class="fas fa-info-circle"></i>&nbsp; Revisar posible diferencia de Costos/Precios en factura con la línea de Producto Recepcionado.
            </div>
          </div>
          <div class="carousel-item">
            <div class="alert alert-info border-0 m-0 text-center">
              <i class="fas fa-info-circle"></i>&nbsp; Revisar si existe diferencia de Cantidad Solicitada en OC vs Cantidad Recibida en Factura de cada línea de producto.
            </div>
          </div>
          <div class="carousel-item">
            <div class="alert alert-info border-0 m-0 text-center">
              <i class="fas fa-info-circle"></i>&nbsp; Revisar si la Unidad de medida de las líneas de Producto coinciden entre la Factura y la Orden de Compra.
            </div>
          </div>
          <div class="carousel-item">
            <div class="alert alert-info border-0 m-0 text-center">
              <i class="fas fa-info-circle"></i>&nbsp; Revisar posible error de Conteo en líneas de productos.
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselPosiblesCausas" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true" style="filter: invert(1);"></span>
          <span class="sr-only">Anterior</span>
        </a>
        <a class="carousel-control-next" href="#carouselPosiblesCausas" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true" style="filter: invert(1);"></span>
          <span class="sr-only">Siguiente</span>
        </a>
      </div>
    </template>

    <template #footer>
      <ButtonProvider
        label="Entendido"
        variant="secondary"
        class="radius_custom"
        data-dismiss="modal"
      />
    </template>
  </ModalProvider>
</template>

<script>
import { ModalProvider, ButtonProvider } from "@/components/atomic";

export default {
  name: "ModalDiscrepanciaUmbrales",
  components: {
    ModalProvider,
    ButtonProvider,
  },
  props: {
    discrepancia: {
      type: Object,
      required: true,
      default: () => ({
        factura: 0,
        conteo: 0,
        diferencia: 0,
        tipo: "",
        umbralFaltante: 0,
        umbralSobrante: 0,
        serie: "",
        documento: "",
        minimo: 0,
        maximo: 0,
      }),
    },
  },
  methods: {
    formatGBP(value) {
      if (value === null || value === undefined) return "0.00";
      return Number(value).toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.radius_custom {
  border-radius: 10px;
}

.carousel-control-prev,
.carousel-control-next {
  width: 8%;
}

#carouselPosiblesCausas {
  min-height: 80px;
  display: flex;
  align-items: center;
}
</style>
